import React, { ReactNode } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { isTabletOrSmallDesktopQuery } from '../../utils'

interface BannerLayoutProps {
  children: ReactNode;
  leftBanner?: ReactNode;
  rightBanner?: ReactNode;
  topBanner?: ReactNode;
}

export const BannerLayout: React.FC<BannerLayoutProps> = ({
                                                            children,
                                                            leftBanner,
                                                            rightBanner,
                                                            topBanner
                                                          }) => {
  const isTabletOrMobile = useMediaQuery(isTabletOrSmallDesktopQuery);

  // If on mobile, just render the content without banners
  if (isTabletOrMobile) {
    return (
      <Container fluid>
        <Row>
          <Col>{children}</Col>
        </Row>
      </Container>
    );
  }

  // On desktop, render with banners
  return (
    <Container fluid>
      {topBanner && (
        <Row className="mb-3">
          <Col>{topBanner}</Col>
        </Row>
      )}
      <Row>
        {leftBanner && (
          <Col xs={12} md={3} lg={2} className="mb-3 mb-md-0">
            {leftBanner}
          </Col>
        )}
        <Col xs={12} md={leftBanner && rightBanner ? 6 : (leftBanner || rightBanner ? 9 : 12)} lg={leftBanner && rightBanner ? 8 : (leftBanner || rightBanner ? 10 : 12)}>
          {children}
        </Col>
        {rightBanner && (
          <Col xs={12} md={3} lg={2} className="mt-3 mt-md-0">
            {rightBanner}
          </Col>
        )}
      </Row>
    </Container>
  );
};
